"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ldflex = require("ldflex");
/**
 * A ContextResolver is a combined resolver/handler that:
 * - resolves a JSON-LD context
 * - handles by returning an object that
 *   - is the initial context passed to the constructor
 *   - allows extending that context by calling `.extend`
 *   - when `await`ed, resolves to the expanded context
 */


var ContextResolver =
/*#__PURE__*/
function (_ldflex$JSONLDResolve) {
  _inherits(ContextResolver, _ldflex$JSONLDResolve);

  function ContextResolver(context) {
    var _this2;

    _classCallCheck(this, ContextResolver);

    var _this;

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ContextResolver).call(this, context));
    _this = _assertThisInitialized(_this2); // Create an exposed version of the initial context, with additional functionality

    var exposedContext = _this2._exposedContext = Object.create(context['@context']); // Allow extending the context

    Object.defineProperty(exposedContext, 'extend', {
      value: function value() {
        var _this3;

        return (_this3 = _this).extendContext.apply(_this3, arguments);
      }
    }); // Resolve to the expanded context

    Object.defineProperty(exposedContext, 'then', {
      value: function value(resolve, reject) {
        return _this2._context.then(resolve, reject);
      }
    });
    return _this2;
  }

  _createClass(ContextResolver, [{
    key: "handle",
    value: function handle() {
      return this._exposedContext;
    }
  }]);

  return ContextResolver;
}(_ldflex.JSONLDResolver);

exports.default = ContextResolver;